import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import { attributes } from 'models/entity';
// Custom
import { entityDataShape } from 'constants/PropTypesShapes';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import EntityIcon from './EntityIcon';

const EntityIdLabel = ({ entity }) => {
  if (entity) {
    const { isMaster, hostsOneparkBookings, name } = attributes(entity);
    return (
      <div className="d-flex align-items-center">
        <div className="d-flex align-items-center mr-2">
          <EntityIcon entity={entity} />
        </div>
        <TruncatedTooltipText>
          <LocalizedMessage id="info.installationEntityName" values={{ isMaster, hostsOneparkBookings, name }} />
        </TruncatedTooltipText>
      </div>
    );
  }
  return null;
};

EntityIdLabel.propTypes = {
  id: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  entity: entityDataShape,
};

EntityIdLabel.defaultProps = {
  entity: null,
};

const mapStateToProps = (state, ownProps) => ({
  entity: _find(state.installation.current.data.entities, ['id', ownProps.id]),
});

module.exports = connect(
  mapStateToProps,
)(EntityIdLabel);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/entities/EntityIdLabel.js